module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mensagemTerceiro",
    class: {
      'm-b': _vm.mensagem.showAvatar
    }
  }, [(_vm.mensagem.showAvatar) ? _c('a', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "width": "32",
      "src": require("assets/img/user-default.png"),
      "alt": _vm.mensagem.remetente.nome
    }
  })]) : _c('span', {
    staticClass: "avatar"
  }), _vm._v(" "), _c('p', {
    staticClass: "msg",
    class: {
      startMessage: _vm.mensagem.startMessage,
        break :_vm.mensagem.showAvatar && !_vm.mensagem.startMessage,
          continue :!_vm.mensagem.showAvatar
    }
  }, [_vm._v(_vm._s(_vm.mensagem.mensagem))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f004c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatConversaMensagemTerceiro.vue
// module id = 1709
// module chunks = 17